import { message } from 'antd';
import type { AxiosResponse } from 'axios';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';
import type { ActionType } from 'typesafe-actions';

import { getMciReportDownloadUrl } from '@portal/api-client/src/analytics/mci-reports';
import { client } from '@portal/api-client/src/client';
import type { SupplySummary } from '@portal/api-models';
import { downloadUrl } from '@portal/common/dist/utils/store-utils';

import * as actions from './actions';
import {
  getSupplySummaryRequestAction,
  mciReportUrlRequestAction,
} from './actions';

export function* getMciReportUrl(
  action: ActionType<typeof actions.mciReportUrlRequestAction.request>
) {
  try {
    const { objectKey, subAccountUuid } = action.payload;

    const url: string = yield call(getMciReportDownloadUrl, {
      objectKey,
      subAccountUuid,
    });

    downloadUrl(url);
    yield put(actions.mciReportUrlRequestAction.success(url));
  } catch (err: any) {
    yield put(actions.mciReportUrlRequestAction.failure(err));
    setTimeout(() => message.error('Issue downloading report'), 100);
  }
}

export function* getSupplySummariesByDemandSubAccountUuid(
  action: ActionType<typeof actions.getSupplySummaryRequestAction.request>
) {
  try {
    const { demandPartnerUuid } = action.payload;

    const { data: response }: AxiosResponse<SupplySummary[]> = yield call(
      [client, 'get'],
      '/analytics/supplySummaries',
      {
        params: {
          demandPartnerUuid,
          limit: 10000,
        },
      }
    );

    yield put(
      actions.getSupplySummaryRequestAction.success({
        demandPartnerUuid,
        response,
      })
    );
  } catch (err: any) {
    yield put(actions.getSupplySummaryRequestAction.failure(err));
  }
}

export function* analyticsSaga() {
  yield takeEvery(getType(mciReportUrlRequestAction.request), getMciReportUrl);
  yield takeEvery(
    getType(getSupplySummaryRequestAction.request),
    getSupplySummariesByDemandSubAccountUuid
  );
}
